export const USER = "USER";
export const MERCHANT = "MERCHANT";
export const TRANSFER = "TRANSFER";
export const ENQUIRY = "ENQUIRY";
export const LOOKUP = "LOOKUP";
export const TRANSACTION = "TRANSACTION";
export const BENEFICIARY = "BENEFICIARY";
export const WALLET = "WALLET";
